/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Microsoft_UnavailableInputs */

const cs_settings_calendar_microsoft_unavailable = /** @type {(inputs: Settings_Calendar_Microsoft_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení Microsoft zatím není dostupné. Požádejte správce, aby na serveru nastavil Outlook kalendář pro produkt.`)
};

const en_settings_calendar_microsoft_unavailable = /** @type {(inputs: Settings_Calendar_Microsoft_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microsoft calendar connect is not available yet. Ask an admin to enable Outlook calendar for this product on the server.`)
};

/**
* | output |
* | --- |
* | "Microsoft calendar connect is not available yet. Ask an admin to enable Outlook calendar for this product on the server." |
*
* @param {Settings_Calendar_Microsoft_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_microsoft_unavailable = /** @type {((inputs?: Settings_Calendar_Microsoft_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Microsoft_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_microsoft_unavailable(inputs)
	return cs_settings_calendar_microsoft_unavailable(inputs)
});